import { createSlice } from "@reduxjs/toolkit";
import { BUSINESS_UNITS } from "../../constants/businessUnits";

const initialState = {
  //SIMULATION
  depotName: "",
  depotCode: "",
  sectorBoundaries: [],
  districtBoundaries: [],
  manifestLocations: [],
  //POSTCODE ALLOCATION
  sectorBoundariesForMultipleDepots: [],
  districtBoundariesForMultipleDepots: [],
  allBoundariesForMultipleAreas: [],
  businessUnitFilter: 1,
};

export const depotSlice = createSlice({
  name: "depot",
  initialState,
  reducers: {
    setDepot: (state, action) => {
      state.depotName = action.payload.depotName;
      state.depotCode = action.payload.depotCode;
    },
    setBoundariesForSingleDepot: (state, action) => {
      state.sectorBoundaries = action.payload.sectorBoundaries;
      state.districtBoundaries = action.payload.districtBoundaries;
    },
    setBoundariesForMultipleDepots: (state, action) => {
      state.sectorBoundariesForMultipleDepots = action.payload.sectorBoundaries;
      state.districtBoundariesForMultipleDepots =
        action.payload.districtBoundaries;
      state.allBoundariesForMultipleAreas = action.payload.allBoundaries;
    },
    setBusinessUnitFilter: (state, action) => {
      if (BUSINESS_UNITS.includes(action.payload)) {
        state.businessUnitFilter = action.payload;
      } else {
        state.businessUnitFilter = 1;
      }
    },
    setManifesetLocations: (state, actions) => {
      state.manifestLocations = actions.payload;
    },
    resetDepotState: (state, action) => {
      state = initialState;
    },
  },
});

const { reducer, actions } = depotSlice;
const {
  setDepot,
  setBoundariesForSingleDepot,
  setBoundariesForMultipleDepots,
  setBusinessUnitFilter,
  setManifesetLocations,
  resetDepotState,
} = actions;
export {
  initialState,
  reducer,
  setDepot,
  setBoundariesForSingleDepot,
  setBoundariesForMultipleDepots,
  setBusinessUnitFilter,
  setManifesetLocations,
  resetDepotState,
};
